<template>
    <app-dialog :isShoppingCartDetails="true" :value="isShoppingCartDialogOpen" @input="$emit('input', $event)" :title="$t(titleKey, { id: normalOrderStore.getPendingCartId })" maxWidth="90vw" :width="getShoppingCartDialogWidth" data-cy="shopping-cart-dialog">
        <template v-slot:content>
            <shopping-cart insideDialog height="auto" minHeight="25vh" maxHeight="55vh" :hasItems="hasItems" :account-blocked-message="accountBlockedMessage"></shopping-cart>
        </template>

        <template v-if="hasItems" v-slot:buttons>
            <app-dialog :isConfirmationDialog="true"  :value="isCancelPendingCartDialogOpen" @input="isCancelPendingCartDialogOpen = $event" :title="$t('layout.attention')" :width="getEmptyCartDialogWidth">
                <template v-slot:content>
                    <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.cart.exitViewModeQuestion') }}</p>
                </template>

                <template v-slot:buttons>
                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isCancelPendingCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text class="myprovet-btn-ok px-8" @click="cancelPendingCart">{{ $t('common.exit') }}</v-btn>
                </template>
            </app-dialog>

            <app-dialog :isConfirmationDialog="true"  :value="isEmptyCartDialogOpen" @input="isEmptyCartDialogOpen = $event" :title="$t('layout.attention')" :width="getEmptyCartDialogWidth">
                <template v-slot:content>
                    <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.cart.emptyCartQuestion') }}</p>
                </template>

                <template v-slot:buttons>
                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isEmptyCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text class="myprovet-btn-ok px-8" @click="clearCart">{{ $t('common.empty') }}</v-btn>
                </template>
            </app-dialog>

            <app-dialog :isConfirmationDialog="true"  :value="isDeletePendingCartDialogOpen" @input="isDeletePendingCartDialogOpen = $event" :title="$t('layout.attention')" :width="getEmptyCartDialogWidth">
                <template v-slot:content>
                    <p class="dark-blue-color pt-4" style="font-size: 16px">{{ $t('orders.cart.deletePendingQuestion') }}</p>
                </template>

                <template v-slot:buttons>
                    <v-btn text outlined class="myprovet-btn-cancel px-8" @click="isDeletePendingCartDialogOpen = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text class="myprovet-btn-ok px-8" @click="deletePendingCart">{{ $t('common.delete') }}</v-btn>
                </template>
            </app-dialog>

            <v-btn v-if="isPendingCart" text outlined class="myprovet-btn-cancel px-8" @click="isDeletePendingCartDialogOpen = true">{{ $t('common.deleteCart') }}</v-btn>

            <v-btn v-if="isPendingCart" text outlined class="myprovet-btn-cancel px-8" @click="isCancelPendingCartDialogOpen = true">{{ $t('common.cancelOperation') }}</v-btn>
            <v-btn v-else text outlined class="myprovet-btn-cancel px-8" @click="isEmptyCartDialogOpen = true">{{ $t('common.empty') }}</v-btn>

            <v-btn text class="myprovet-btn-ok px-8" @click="finishPurchase">{{ $t('common.order') }}</v-btn>
        </template>
    </app-dialog>
</template>

<script>
import { mapStores } from 'pinia';
import { useBranchStore } from '@/Stores/branch';
import { useUserStore } from '@/Stores/user';
import { useNormalOrderStore } from '@/Stores/normalorder';
import { axios } from '@/Services/Backend';

export default {
    props: {
        isShoppingCartDialogOpen: {
            type: Boolean,
            default: false,
        },

        accountBlockedMessage: String,
    },

    data() {
        return {
            isEmptyCartDialogOpen: false,
            isCancelPendingCartDialogOpen: false,
            isDeletePendingCartDialogOpen: false,
            isPendingCart: false,
            titleKey: 'cart.title',
        };
    },

    computed: {
        ...mapStores(useUserStore, useBranchStore, useNormalOrderStore),

        hasItems() {
            return this.normalOrderStore.getProductCount > 0 || this.normalOrderStore.getCampaignCount > 0;
        },

        getShoppingCartDialogWidth() {
            return this.getResponsiveDialogWidth('90vw', '65vw');
        },

        getEmptyCartDialogWidth() {
            return this.getResponsiveDialogWidth('60vw', '35vw');
        },
    },

    watch: {
        'normalOrderStore.getPendingCartId': {
            handler: function (pendingCartId) {
                // Watch the id and not the status, as the id can change without a status change
                if (pendingCartId && pendingCartId > -1) {
                    this.titleKey = 'cart.pendingTitle';
                    this.isPendingCart = true;
                } else {
                    this.titleKey = 'cart.title';
                    this.isPendingCart = false;
                }
            },
            immediate: true,
        },
    },
    destroyed(){
        var element = document.getElementById("app");
        element.classList.remove("fix-background");
    },
    methods: {
        deletePendingCart() {
            const targetCartId = this.normalOrderStore.getPendingCartId;

            axios
                .delete('/api/orders/pending-carts/' + targetCartId)
                .then(() => {
                    this.isDeletePendingCartDialogOpen = false;
                    this.normalOrderStore.clearCartAndNotify({ showMessage: false, sendSharedCart: false });
                    window.EventBus.$emit('refresh-pending-carts');
                    this.showSuccess(this.$t('orders.cart.pendingDeleted'));
                    window.EventBus.$emit('refresh-shared-cart', { leavingPendingCartMode: true });
                    window.EventBus.$emit('refresh-shared-cart-subscription', {});

                    if (window.location.pathname.startsWith('/orders/normal/cart') || window.location.pathname.startsWith('/orders/normal/summary')) {
                        this.$inertia.visit('/orders/normal');
                        return;
                    }
                })
                .catch((error) => {
                    this.showError(this.$t('orders.cart.deletePendingError'));
                    this.isDeletePendingCartDialogOpen = false;
                });
        },

        clearCart() {
            if(!this.checkConnection()){
                this.showError(this.$t('common.noInternet'));
                return
            }
            this.isEmptyCartDialogOpen = false;
            this.normalOrderStore.clearCartAndNotify({});
        },

        cancelPendingCart() {
            this.isCancelPendingCartDialogOpen = false;
            this.normalOrderStore.clearCartAndNotify({ showMessage: false, sendSharedCart: false });
            window.EventBus.$emit('refresh-shared-cart', { leavingPendingCartMode: true });
            window.EventBus.$emit('refresh-shared-cart-subscription', {});

            if (window.location.pathname.startsWith('/orders/normal/cart') || window.location.pathname.startsWith('/orders/normal/summary')) {
                this.$inertia.visit('/orders/normal');
                return;
            }
        },

        finishPurchase() {
            if (this.branchStore.isBlocked) {
                this.showError(this.accountBlockedMessage);
                return;
            }

            if (!window.location.pathname.startsWith('/orders/normal/cart')) {
                const client_number = this.branchStore.branch?.client_number;
                const company_branch = this.branchStore.branch?.company_branch;

                this.$inertia.visit(`/orders/normal/cart/${client_number}/${company_branch}`);
            }

            this.$emit('input', false);
        },
    },
};
</script>
